import { render, staticRenderFns } from "./SvgPlayer.vue?vue&type=template&id=33cc1936&scoped=true"
import script from "./SvgPlayer.vue?vue&type=script&lang=js"
export * from "./SvgPlayer.vue?vue&type=script&lang=js"
import style0 from "./SvgPlayer.vue?vue&type=style&index=0&id=33cc1936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc1936",
  null
  
)

export default component.exports